import { DISABLED_ORDERS_DATE } from '@trwl/constants';
import { Container } from '@trwl/layout';
import { useMemo } from 'react';

export const InfoRow = () => {
  const disabledOrders = useMemo(() => {
    if (!DISABLED_ORDERS_DATE) return false;
    const currentDate = new Date();
    return DISABLED_ORDERS_DATE > currentDate;
  }, []);

  const dateText = useMemo(() => {
    if (!DISABLED_ORDERS_DATE) return '';
    return DISABLED_ORDERS_DATE.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
    });
  }, []);

  if (!disabledOrders) return null;
  return (
    <div className={'w-full text-center bg-red-500 py-1'}>
      <Container>
        Временно не принимаем заказы. Продолжим работу с {dateText}
      </Container>
    </div>
  );
};
